module.exports = __webpack_public_path__ + "static/img/package_5.c02d244.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_5.jpg
// module id = ZaYd
// module chunks = 1